module.exports = __webpack_public_path__ + "img/hzsfnetylzx.82bc55f1.png";